import React from 'react';
const SvgSignalCellularConnectedNoInternet2Bar = (props) => {
    return (<svg viewBox='0 0 24 24' fill='currentColor' className='svg-icon' {...props}>
			<path d='M0 0h24v24H0V0z' fill='none'/>
			<path d='M22 8V2L2 22h16V8h4z' fillOpacity={0.3}/>
			<path d='M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z'/>
		</svg>);
};
export default SvgSignalCellularConnectedNoInternet2Bar;
